/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// We assumed global variables our in Sprockets-based JavaScript,
// so any module bundled by Webpack would need to be exposed to the global scope somehow,
require('../lib/LeavingAlert');
require('../lib/ToggleShowPassword');
require('../lib/PreventToUseStableBfcache');
require('../lib/pwa');

const requireAll = (r) => r.keys().forEach(r);
requireAll(require.context('../pages', true, /\.(coffee|js|ts)$/));
